import { $ } from './../helpers/query'
import Swiper from './../imports/import-swiper'

export default () => {
  $('.gallery').each((section) => {

    const carouselCont = section.querySelector('.gallery__carousel');
    let carousel;
    carouselInit()

    function carouselInit() {
      carousel = new Swiper(carouselCont, {
        init: false,
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 22,
        setWrapperSize: true,
        navigation: {
          nextEl: section.querySelector('.gallery__next'),
          prevEl: section.querySelector('.gallery__prev'),
        },
        breakpoints: {
          1180: {
            slidesPerView: 2,
            slidesPerColumn: 3,
          },
          639: {
            slidesPerView: 1.25,
            slidesPerColumn: 2,
            spaceBetween: 19,
            setWrapperSize: true,
          }
        }
      })
    }

    if (document.documentElement.clientWidth <= 1180 && document.documentElement.clientWidth >= 640) {
      changeTabletLayout()
    }
    carousel.init()

    function changeTabletLayout() {
      if (document.documentElement.clientWidth > document.documentElement.clientHeight) {
        carousel.params.breakpoints[1180] = {
          slidesPerView: 3,
          slidesPerColumn: 2,
        }
      } else {
        carousel.params.breakpoints[1180] = {
          slidesPerView: 2,
          slidesPerColumn: 3,
        }
      }
    }

    window.addEventListener('resize', () => {
      if (document.documentElement.clientWidth <= 1180 && document.documentElement.clientWidth >= 640) {
        carousel.destroy()
        carouselInit()
        changeTabletLayout()
        carousel.init()
      }
    })
  })
}
